/**
 * Created by rathompson on 6/27/22
 * File: InstanceReducer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { groupBy, uniqBy, keyBy } from 'lodash'

import {
  SET_INSTANCES
} from './actions/InstanceReducer.actions'

const initState = {
  flatInstances: [],
  instancesByTSG: {},
  instanceMap: {}
}

const setInstances = (state, { instances = [] }) => {
  const flatInstances = uniqBy([...state.flatInstances, ...instances], 'tenant_id')
  const instancesByTSG = groupBy(flatInstances, 'tsg_id')
  const instanceMap = keyBy(flatInstances, 'tenant_id')
  return { ...state, flatInstances, instancesByTSG, instanceMap }
}

const InstanceReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_INSTANCES:
      return setInstances(state, action)
    default:
      return state
  }
}

InstanceReducer.initialState = initState
export default InstanceReducer

